import { UnitStateGroupEnumType } from '@mark43/cad-api';
import { GenericObject } from '../common/types';

export const hospitalTransportUnitStateGroups: UnitStateGroupEnumType[] = [
    'HOSPITAL_TRANSPORT_ARRIVED',
    'HOSPITAL_TRANSPORT_EN_ROUTE',
];

export const transportDrawerTitlesPerUnitStateGroup: GenericObject<string> = {
    TRANSPORT_ARRIVED: 'Transport (Arrived)',
    HOSPITAL_TRANSPORT_ARRIVED: 'Hospital (Arrived)',
    TRANSPORT_EN_ROUTE: 'Transport (En Route)',
    HOSPITAL_TRANSPORT_EN_ROUTE: 'Hospital (En Route)',
};
